export default {
    configuration: {
        title: 'Configuration',
    },
};
